(function ($) {
    
    var svgInit = function() {
        
        var loadSVGFilled = $.get('/propertyibe2/resources/images/svg-filled.json')
        var loadSVGOutline = $.get('/propertyibe2/resources/images/svg-outline.json')
        var svgLoaded = $.when(loadSVGFilled, loadSVGOutline).then((f, o) => {
            return {
                filled: f[0],
                outline: o[0]
            }
        })

        svgLoaded.then(svgicon => {
            var svgBuilder = function (el, style) {
                var style = style || 'filled';

                if (!svgicon[style].hasOwnProperty(el.dataset.svg))
                    return;

                var xmlns = 'http://www.w3.org/2000/svg';
                var icon = svgicon[style][el.dataset.svg];
                var attributes = {
                    w: el.dataset.svgWidth,
                    h: el.dataset.svgHeight,
                    f: el.dataset.svgColor || 'currentColor',
                    c: el.dataset.svgClass || null,
                    s: el.getAttribute('style') || null
                }

                var title = document.createElementNS(null, "title")
                title.insertAdjacentText("afterbegin", icon[0])

                var path = document.createElementNS(xmlns, "path")
                path.setAttribute("d", icon[3])

                var svgel = document.createElementNS(xmlns, "svg")
                svgel.setAttribute("version", "1.1")
                svgel.setAttribute("viewBox", `0 0 ${icon[1]} ${icon[2]}`)
                svgel.setAttribute("aria-hidden", "true")
                if (attributes.w)
                    svgel.setAttribute("width", attributes.w)
                if (attributes.h)
                    svgel.setAttribute("height", attributes.h)
                if (attributes.f)
                    svgel.setAttribute("fill", attributes.f)
                if (attributes.c)
                    svgel.setAttribute("class", attributes.c)
                if (attributes.s)
                    svgel.setAttribute("style", attributes.s)

                svgel.insertAdjacentElement("beforeend", title)
                svgel.insertAdjacentElement("beforeend", path)

                el.insertAdjacentElement("afterend", svgel)
                el.parentNode.replaceChild(document.createComment(el.outerHTML), el);
            }

            $('[data-svg]').each(function () {
                var style = this.dataset.svgStyle || 'filled';
                svgBuilder(this, style);
            })

            $(document).observer(function (mu) {
                mu.forEach(m => {
                    var nodes = m.addedNodes
                    nodes.forEach(node => {
                        if (node.nodeType !== 1)
                            return;
                        if ($(node).is('[data-svg]')) {
                            var style = node.dataset.svgStyle
                            svgBuilder(node, style);
                        } else if ($(node).find('[data-svg]').length) {
                            $(node).find('[data-svg]').each(function () {
                                var style = this.dataset.svgStyle
                                svgBuilder(this, style)
                            })
                        }
                    })
                })
            }, {
                subtree: true,
                childList: true,
                characterData: false
            })
        })
    }
    
    if (window.SVGInit === undefined) {
        window.SVGInit = svgInit;
    }
    window.SVGInit();
    
})(jQuery);